import React from "react";
import TransactionsReportView from "./TransactionsReportView";

/* "All" tab — regular + admission transactions together, so it carries both
   the Payment Mode column and the combined Emis ID / Admission ID column. */
const AllFeesTransactionsReport = () => {
  return <TransactionsReportView type="all" />;
};

export default AllFeesTransactionsReport;
